import R from 'ramda'
import {
  ACTIONS
  // PAGES,
} from '../constants'
import {
  isNilOrEmpty
} from '../utils'

const actionIs = R.pathEq(['action', 'type'])

const setTab = ({state, action}) => {
  return R.assoc('pageName', action.pageName, state)
}
/*
const setNavigation = ({state, action}) => {
  const {pageName, pageNum = 1, perPage = 20, ids = []} = action
  const navPath = ['pages', pageName, 'navigation']
  return R.compose(
    R.assoc('pageName', pageName),
    R.assocPath(navPath, {pageNum, perPage, ids})
  )(state)
}
*/

const setUserLoggedOut = ({state, action}) => {
  const authStatus = {
    user: null,
    navigatingTo: R.path(["locationPath"], action),
    request: R.merge(
      R.path(['authStatus', 'request'], state),
      {
        xhr: null,
        progress: 0,
        isLoading: false,
        error: isNilOrEmpty(action.error) ? null : action.error
      }
    )
  }
  return R.assoc('authStatus', authStatus, state)
}

const reducer = [
  // [actionIs(ACTIONS.NAVIGATION.GO_TO), setNavigation],
  [actionIs(ACTIONS.NAVIGATION.GO_TO_TAB), setTab], // this will set the tab AND our epic will push onto history
  [actionIs(ACTIONS.NAVIGATION.SET_TAB), setTab], // this just switches tabs
  [actionIs(ACTIONS.NAVIGATION.GO_TO_LOGIN), setUserLoggedOut]
]

export default reducer



// WEBPACK FOOTER //
// ./webAdmin/reducers/navigate.js